import { render, staticRenderFns } from "./validations-list.vue?vue&type=template&id=76ccfb36"
import script from "./validations-list.vue?vue&type=script&lang=js"
export * from "./validations-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports